import React, {useContext, useEffect, useState} from "react";
import {AuthContext} from "../../context/AuthContext";
import {
    Button,
    Card,
    CardContent,
    Checkbox,
    ClickAwayListener,
    FormControlLabel,
    IconButton,
    Typography
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import {doc, updateDoc} from "firebase/firestore";
import {db} from "../../Firebase";
import {kLibrettoUserCollectionName} from "../../utils/CollectionConstants";

const LibrettoV2PopupCard = ({ onClose, userId, isLifetimePlanUser }) => {
    const [notifyMeChecked, setNotifyMeChecked] = useState(false);

    useEffect(() => {
        const markPopupSeen = async () => {
            const entityRef = doc(db, kLibrettoUserCollectionName, userId);
            try {
                await updateDoc(entityRef, { hasSeenAppSumoPopup: true });
                console.log("Updated hasSeenLibrettoV2Popup to true for user: ", userId);
            } catch (error) {
                console.error("Error updating hasSeenLibrettoV2Popup: ", error);
            }
        };

        markPopupSeen();
    }, [userId]);

    const handleCheckboxChange = async (e) => {
        const checked = e.target.checked;
        setNotifyMeChecked(checked);

        const entityRef = doc(db, kLibrettoUserCollectionName, userId);
        try {
            await updateDoc(entityRef, { notifyMeOnLaunch: checked });
            console.log("notifyMeOnLaunch updated to: ", checked);
        } catch (error) {
            console.error("Error updating notifyMeOnLaunch: ", error);
        }
    };

    return (
        <Box
            sx={{
                position: "fixed",
                top: "calc(50% - 200px)",
                left: "calc(50% - 320px)",
                width: "640px",
                padding: "24px 24px 32px",
                display: "flex",
                flexDirection: "column",
                gap: "24px",
                borderRadius: "12px",
                zIndex: 1000,
                background: "#FFFFFF",
                fontFamily: "Inter",
                boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
                borderTop: "4px solid #2B6BFD",
            }}
        >
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                    <Typography
                        sx={{
                            fontSize: "18px",
                            fontWeight: 600,
                            lineHeight: "24px",
                            letterSpacing: "0.18px",
                            color: "#1A1A1A",
                        }}
                    >
                        Libretto V2 is coming July 🚀
                    </Typography>
                    <Typography
                        sx={{
                            fontSize: "18px",
                            fontWeight: 500,
                            lineHeight: "20px",
                            color: "#2B6BFD",
                        }}
                    >
                        A faster, simpler way to record and edit, audio and video.
                    </Typography>
                    <Typography
                        sx={{
                            fontSize: "16px",
                            fontWeight: 500,
                            lineHeight: "20px",
                            letterSpacing: "0.14px",
                            color: "#555",
                            maxWidth: "500px",
                        }}
                    >
                        Rebuilt with the reliability and features you’ve asked for.
                    </Typography>
                    {/*{isLifetimePlanUser && <Typography*/}
                    {/*    sx={{*/}
                    {/*        fontSize: "16px",*/}
                    {/*        fontWeight: 500,*/}
                    {/*        lineHeight: "20px",*/}
                    {/*        letterSpacing: "0.14px",*/}
                    {/*        color: "#555",*/}
                    {/*        maxWidth: "500px",*/}
                    {/*    }}*/}
                    {/*>*/}
                    {/*    Thank you for being a lifetime plan buyer.*/}
                    {/*</Typography>}*/}
                </Box>
                <IconButton sx={{ marginTop: "-4px" }} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            </Box>

            <FormControlLabel sx={{ marginTop: "-16px"}}
                control={
                    <Checkbox
                        checked={notifyMeChecked}
                        onChange={handleCheckboxChange}
                        icon={<Checkbox sx={{ color: "#999" }} />}
                        checkedIcon={<Checkbox sx={{ color: "#2B6BFD" }} />}
                    />
                }
                label={
                    <Typography
                        sx={{
                            fontSize: "16px",
                            fontWeight: 500,
                            lineHeight: "20px",
                            letterSpacing: "0.14px",
                            color: "#1A1A1A",
                        }}
                    >
                        Notify me when it launches
                    </Typography>
                }
            />
        </Box>
    );
};

export default LibrettoV2PopupCard;